module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "youtube-responsive",
    style: (_vm.styleObject)
  }, [_c('div', {
    staticClass: "aspect"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.youtubeEmbed) ? _c('iframe', {
    attrs: {
      "title": _vm.vidTittle,
      "width": "100%",
      "height": "100%",
      "src": 'https://www.youtube.com/embed/' + _vm.youtubeEmbed,
      "frameborder": "0",
      "allow": "autoplay",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoEmbed) ? _c('video', {
    attrs: {
      "id": "video1",
      "title": _vm.vidTittle,
      "width": "100%",
      "height": "100%",
      "autoplay": "",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoPath,
      "type": "video/mp4"
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dd0aa86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Videoimport.vue
// module id = 1035
// module chunks = 1